module.exports = __webpack_public_path__ + "media/images/weather/441_night-3955deb14015bd0bc97d5ec62cfe24b9.png";